import Cookies from "js-cookie";
// 在url后面加参数debug=true开启本地调试
let isDebug = false;
const isLoc = location.host.indexOf("localhost") > -1; //本地环境

const DOMAIN = location.host;
let API_DOMAIN = "henduoke.ttrushi.com";

//华发营销配置
let HF_YXCONFIG = {};

let isMp = false;
if (isLoc || location.port) {
  // 本地环境,从fake获取
  (function() {
    let tmpObj = {};

    if (tmpObj.fake) {
      Cookies.set("fake", tmpObj.fake, { expires: 60 * 60 * 1 });
    } else if (Cookies.get("fake")) {
      tmpObj.fake = Cookies.get("fake");
    } else {
      alert("没有url fake参数，也没有cookie fake参数");
    }
    if (tmpObj.fake) {
      if (tmpObj.fake.split("_")[0] == "hfdev") {
        // 华发测试环境
        // 内网：sales-int.paasdev.huafagroup.com/huafa/weixin
        // 外网：sales.test.huafagroup.com/huafa/weixin
        API_DOMAIN = "https://sales-int.huafagroup.com/huafa/weixin";
      } else if (tmpObj.fake.split("_")[0] == "hfpro") {
        // 华发生产环境
        API_DOMAIN = "https://sap.huafatech.com/huafa/weixin";
      } else {
        API_DOMAIN = tmpObj.fake.split("_")[0] + ".ttrushi.com";
      }
    } else {
      alert("没有fake参数");
    }
    if (tmpObj.ismp && tmpObj.ismp == "1") {
      isMp = true;
    }
  })();
} else {
  if (location.host.indexOf("huafacrm.com") > -1) {
    // 华发测试环境
    // 内网：sales-int.paasdev.huafagroup.com/huafa/weixin
    // 外网：sales.test.huafagroup.com/huafa/weixin
    API_DOMAIN = "https://sales-int.huafagroup.com/huafa/weixin";
  } else if (location.host.indexOf(".huafamarkting.") > -1) {
    // 华发生产环境
    API_DOMAIN = "https://sap.huafatech.com/huafa/weixin";
  } else {
    // 其它
    API_DOMAIN =
      location.hostname.substring(0, location.hostname.indexOf(".")) +
      ".ttrushi.com";
  }
}

const FAKE_DATA = {
  qmyx_hope: {
    openid: "oj3y9wGThdLqhn0bZWOj7DeO2Tww",
    passport: "b4de197ab7b03e9d014116821e90d54f",
    flag: 1,
    issubscribe: 1
  },
  qmyx_zzf: {
    // 全民营销-张振飞
    openid: "oU9KX04kPluVNGhOvUoq8y-BziVw",
    passport: "9f95d43ee7bcc87a5ea2ffd1be4e86b1",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_lwt: {
    // 全民营销-刘伟涛
    openid: "oU9KX0y1u3LzKYJ_UYCcC8v6X2lw",
    passport: "973cbddd5707f39bbfe0bea5bb542c8e",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_zyf: {
    // 全民营销-郑一帆
    openid: "oU9KX06oCLP078D2-bdS8xFWIDqE",
    passport: "cf880fff9446b71c042f924dafe00b71",
    flag: 1,
    issubscribe: 1
  },
  qmyx_cy: {
    //全民营销-陈怡
    openid: "oU9KX09j81LjFNwEHeTDAHWeNkzo",
    passport: "4b18535c8f49958b041f897f768f9148",
    flag: 1,
    issubscribe: 1
  },
  qmyx_dym: {
    // 丁元梦
    openid: "oj3y9wPtClayVSbajzca5k5DJqeY",
    passport: "c929f81258b755b69f91cb202b5a2686",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_yl: {
    //远霖
    openid: "oU9KX0zX9SN3oLKAD6zncTj3jU6Y",
    passport: "07929e7f043ef59c05ca82266ad3e98c",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_yjh: {
    //叶浚豪
    openid: "oU9KX030L5BZMwRidiP4_spzG6Y4",
    passport: "32962a1baa1e861276322c970d861920",
    flag: 1,
    issubscribe: 1
  },
  // 华发开发环境
  hfdev_qmyx_hope: {
    openid: "oU9KX03tr4c0l92nSICJB-lLGDno",
    passport: "042512975eff169c7a84dea5d3089bff",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_cxt: {
    openid: "oU9KX06EsVrM-HIAFPA6xNf5nouk",
    passport: "3ece0e7ac65115ca924c0717ad7e1349",
    flag: 1,
    issubscribe: 1
  },
  //测试环境全民营销客户
  hfdev_qmyx_hf: {
    openid: "oU9KX00RAY0Qky79HNlw8iEu-8Lo",
    passport: "c8ccb494f14290cf67019a5bd09a194c",
    flag: 1,
    issubscribe: 1
  },
  // 珠海华发置业管家 公众号改名为 华发置业通珠海
  hfpro_zhhfzygj_hope: {
    openid: "omkQy0iKw4FYLynp-CXsUSZmBwSI",
    passport: "e8f3ddd0117fa964b120a9296a38e464",
    flag: 1,
    issubscribe: 1
  },
  // 华发南京
  hfpro_zyhfnj_hope: {
    openid: "oDyJbxFSk_1k0RC4D1kA_rKIdKQY",
    passport: "8d998fa0681ae28e25ea59580380a793",
    flag: 1,
    issubscribe: 1
  },
  // 安联e家
  // http://alej.abotz.com/h5/t9?id=144051&psn=dc6e3a1723774a72b7e39e9036d9a14b
  alej_hope: {
    openid: "o3N5ewqRxvPBnm1_ffKz7_mn5dy0",
    passport: "33857cade360243e406dd6b91caae330",
    flag: 1,
    issubscribe: 1
  },
  // 安联e家 陈珺
  alej_chenjun: {
    openid: "o3N5ewvqqeY9eZ-WL4zvc1Z98d4c",
    passport: "8a9caa37477e2d29832a778c8b5ae938",
    flag: 1,
    issubscribe: 1
  },
  //中海贵阳
  gyzhy_gj: {
    openid: "oCkbD6IsuA-ArSGvJKGkCoYDm-O0",
    passport: "c0e082a97f981fb963bf1b822f5966f3",
    flag: 1,
    issubscribe: 1
  }
};

// 小程序配置的域名
const MP_DOMAIN = {
  // downloadFile合法域名
  DOWNLOAD: [
    "https://app.work.weixin.qq.com",
    "https://assets.rurushishi.com",
    "https://assets.wxmp.ruthus.com",
    "https://bang.qq.com",
    "https://finance.qq.com",
    "https://gu.qq.com",
    "https://hdk.rstthd.com",
    "https://mp.weixin.qq.com",
    "https://sticker.weixin.qq.com",
    "https://tcp.tencent.com",
    "https://test.tcp.tencent.com",
    "https://web.wechat.com",
    "https://web1.wechat.com",
    "https://web2.wechat.com",
    "https://work.weixin.qq.com",
    "https://wx.qlogo.cn",
    "https://wx.qq.com",
    "https://wx2.qq.com",
    "https://wx8.qq.com",
    "https://wzq.tenpay.com"
  ],
  // 业务域名
  BUSINESS: [
    "https://henduoke.quanc.com.cn",
    "https://henduoke.rushizhineng.com",
    "https://rushi.rushizhineng.com",
    "https://wxmppage.ruthus.com"
  ],
  // 华发置业通 小程序
  BUSINESS_HUAFA: [
    "homtop.cn",
    "huafacrm.com",
    "huafamarkting.com",
    "img360wcs.soufunimg.com",
    "infishow.ideamake.cn",
    "rushifckj.com",
    "ruthyx.com",
    "sales.test.huafagroup.com",
    "sap.huafatech.com",
    "img360wcs02.fang.com",
    "fengting.io",
    "external.fang.anjuke.com",
    "huafa.ideamake.cn"
  ]
};

export default {
  API_DOMAIN,
  HF_YXCONFIG,
  FAKE_DATA,
  isDebug,
  isLoc,
  isMp,
  MP_DOMAIN,
  DOMAIN
};
